import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import update from 'immutability-helper';
import { connect } from 'react-redux';
import QuestionsContainer from '../../common/QuestionsContainer';
import ClaimPastRole from './ClaimPastRole';
import chemistImg from '../../../../assets/images/referral-person.jpg';
import { putRequest } from '../../../requestUtils';
import { analyticsTrack } from '../../../analyticsUtils';
import './Beginning.scss';
import Tooltip from '../../common/Tooltip';
import { processedProfileSuggestions } from '../onboardingUtils';

class Beginning extends Component {
  constructor(props) {
    super(props);

    const {
      bio,
      location,
      education,
      pastRoles,
      functionalAreas,
      therapeuticAreas,
      industries,
      productTechnologies,
      stagesOfDevelopments,
    } = props;
    this.state = {
      page: 0,
      wasQuestionsUpdated: false,
      experiences: {},
      location,
      bio,
      education,
      pastRoles,
      functionalAreas,
      industries,
      productTechnologies,
      therapeuticAreas,
      stagesOfDevelopments,
      newResume: false,
    };
    this.questionsUpdated = this.questionsUpdated.bind(this);
    this.moreThanTwoExperiences = this.moreThanTwoExperiences.bind(this);
    this.toggleExperience = this.toggleExperience.bind(this);
    this.initProfileSuggestions = this.initProfileSuggestions.bind(this);
    this.handleUpdateTags = this.handleUpdateTags.bind(this);
    this.handleUpdatePastRoles = this.handleUpdatePastRoles.bind(this);
    this.handleUpdateEducations = this.handleUpdateEducations.bind(this);
    this.handleUpdateBio = this.handleUpdateBio.bind(this);
    this.handleUpdateLocation = this.handleUpdateLocation.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.claimInfo = this.claimInfo.bind(this);
    this.renderNavigationButtons = this.renderNavigationButtons.bind(this);
    this.handleNewResume = this.handleNewResume.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      bio,
      location,
      education,
      pastRoles,
      functionalAreas,
      therapeuticAreas,
      industries,
      productTechnologies,
      stagesOfDevelopments,
    } = nextProps;
    this.setState({
      bio,
      location,
      education,
      pastRoles,
      functionalAreas,
      therapeuticAreas,
      industries,
      productTechnologies,
      stagesOfDevelopments,
    });
  }

  questionsUpdated() {
    this.setState({ wasQuestionsUpdated: true });
  }

  claimInfo(position) {
    const {
      claimInfoUrl, csrfToken, questionnaire,
      updateQuestionnaire, userId, handleMenuUpdate,
      errorsProfileSuggestions,
    } = this.props;
    const { page, pastRoles } = this.state;

    analyticsTrack('Clicked on Next', {
      location: 'Onboarding Flow',
      step: 'Start Here',
      position,
      userId,
    });

    let updatedQuestionnaire;
    let data;
    if (page === 0) {
      if (errorsProfileSuggestions.is) {
        return;
      }

      data = processedProfileSuggestions(this.state);
      updatedQuestionnaire = questionnaire;
    }
    if (page === 1) {
      data = this.state.experiences;
      Object.keys(data).forEach((key) => { data[key] = data[key].filter((item) => !item.remove); });
      updatedQuestionnaire = questionnaire.filter((questions) => (questions.every((q) => !Object.keys(data).includes(q.question_key))
      ));
    } else if (page === 2) {
      updatedQuestionnaire = questionnaire.filter((questions) => (questions.every((q) => q.question_key !== 'past_roles')));
      data = { past_roles: pastRoles.filter((item) => !item.remove) };
    }
    putRequest(
      claimInfoUrl,
      { claim_info: data },
      csrfToken,
    )
      .then(() => {
        updateQuestionnaire(updatedQuestionnaire);
        this.nextPage();
        handleMenuUpdate(true);
      });
  }

  moreThanTwoExperiences() {
    const { experiences } = this.state;
    return Object.values(experiences).filter((exp) => exp.length > 0).length >= 2;
  }

  toggleExperience(experienceCategory, experience) {
    const { experiences } = this.state;
    const index = experiences[experienceCategory].findIndex((x) => x.name === experience);
    const boolean = experiences[experienceCategory][index].remove || false;
    this.setState({
      experiences: update(experiences, {
        [experienceCategory]: { [index]: { $merge: { remove: !boolean } } },
      }),
    });
    analyticsTrack(`${boolean ? 'Add' : 'Delete'} experience`, {
      location: 'Onboarding Flow',
      specific_location: 'Claim Info',
      experience_category: experienceCategory,
    });
  }

  initProfileSuggestions(profileSuggestions) {
    this.setState({ ...profileSuggestions });
  }

  handleNewResume(cleared) {
    this.setState({ newResume: cleared });
  }

  handleUpdateTags(id, updatedTags) {
    this.setState({ [id]: updatedTags });
  }

  handleUpdatePastRoles(updatedPastRoles) {
    this.setState({ pastRoles: updatedPastRoles });
  }

  handleUpdateEducations(updatedEducation) {
    this.setState({ education: updatedEducation });
  }

  handleUpdateBio(updatedBio) {
    this.setState({ bio: updatedBio });
  }

  handleUpdateLocation(updatedLocation) {
    this.setState({ location: updatedLocation });
  }

  nextPage() {
    const { setStateQuestionnaire, handleNextStep } = this.props;
    const { education, pastRoles } = this.state;
    setStateQuestionnaire({ education, past_roles: pastRoles });
    handleNextStep();
  }

  renderInfo() {
    const { page, pastRoles } = this.state;
    if (page === 1) {
      return (
        <div className="experiences">
          <h1 className="mb-24">Experience</h1>
          {this.renderExperiences('Functional Areas', 'functional_areas')}
          {this.renderExperiences('Therapeutic Areas', 'therapeutic_areas')}
          {this.renderExperiences('Product Technologies', 'product_technologies')}
          {this.renderExperiences('Industries', 'industries')}
          {this.renderExperiences('Stages of Development', 'stages_of_development')}
          {this.renderExperiences('Diseases/Indications', 'diseases_/_indications')}
        </div>
      );
    } if (page === 2) {
      return (
        <div className="past-roles body-text-2">
          <h1 className="mb-24">Past Roles</h1>
          {pastRoles.map((pastRole, index) => (
            <ClaimPastRole
              index={index}
              pastRole={pastRole}
              handleUpdatePastRole={this.handleUpdatePastRole}
            />
          ))}
        </div>
      );
    }
    return null;
  }

  renderExperiences(header, experience) {
    const { experiences } = this.state;
    const exps = experiences[experience];
    if (exps && exps.length > 0) {
      return (
        <div className="experience">
          <div className="body-text-2 medium-weight experience-name">{header}</div>
          {exps.map((exp) => (
            <span key={exp.name} className={`badge small blue-light ${exp.name.replace(/ +/g, '-').toLowerCase()} ${exp.remove && 'do-not-add'}`}>
              <span>{exp.name}</span>
              <i
                className={`remove-tag fa fa-${exp.remove ? 'plus' : 'times'} ms-2`}
                onClick={() => this.toggleExperience(experience, exp.name)}
                role="presentation"
              />
            </span>
          ))}
        </div>
      );
    }
    return null;
  }

  renderNavigationButtons(position) {
    const { onboardType, uploadingResume } = this.props;
    const { page } = this.state;
    const isUploadingResume = uploadingResume && page === 0;

    return (
      <Fragment>
        {isUploadingResume && position === 'bottom'
          && (
          <div className="resume-upload-info">
            Please wait for resume file to finish uploading.
          </div>
          )}
        <div className={`questionnaire-navigation-buttons ${position}`}>
          <button
            className={`btn 
            ${isUploadingResume ? 'btn-disabled' : 'btn-primary-darkest'}
            ${onboardType}-continue-clora-profile-setting`}
            onClick={() => this.claimInfo(position)}
          >
            Next
            {' '}
            <i className="fa fa-chevron-right" />
          </button>
        </div>
      </Fragment>
    );
  }

  render() {
    const {
      questionnaire,
      questionnaireName,
      questionableId,
      questionableType,
      csrfToken,
      isOwner,
      updateMenu,
      handleMenuUpdate,
      handleResumeUpload,
    } = this.props;
    const questionnaireQuestionIds = questionnaire[0].map((x) => x.id);
    const { page, newResume } = this.state;

    if (page === 0) {
      return (
        <div className="main-container">
          <div className="questionnaire-nav">
            <div className="questionnaire-nav-container">
              <div>
                <h5 className="category-name">Start Here!</h5>
                <div className="header-subtext">
                  This is where you start building your profile.
                </div>
              </div>
              {this.renderNavigationButtons('top')}
            </div>
          </div>
          <QuestionsContainer
            questionnaireName={questionnaireName}
            questionIds={questionnaireQuestionIds}
            questionableId={questionableId}
            questionableType={questionableType}
            csrfToken={csrfToken}
            owner={isOwner}
            questionsUpdated={this.questionsUpdated}
            updateMenu={updateMenu}
            handleMenuUpdate={handleMenuUpdate}
            handleNewResume={this.handleNewResume}
            handleResumeUpload={handleResumeUpload}
          />
          {newResume && (
          <Tooltip
            title="HURRAY!"
            description="We filled your profile based on your resume content.
                        Please review and confirm in the next screens."
          />
          )}

          {this.renderNavigationButtons('bottom')}
        </div>
      );
    }
    return (
      <div className="onboarding-beginning claim-info">
        <Row className="header">
          <Col sm={9} className="text">
            <h1 className="bold mb-12">We found some profile suggestions for you!</h1>
            <h2 className="normal-weight">
              ✦ You can add it now to your profile and edit it at any time.
            </h2>
          </Col>
          <Col sm={3} className="img-container">
            <img
              alt="chemist-img"
              className="d-none d-sm-block pull-right"
              src={chemistImg}
            />
          </Col>
        </Row>
        <div className="clorify-info">
          {this.renderInfo()}
        </div>
        <div className="claim-info-actions">
          <div className="actions">
            <h2>Do you want to add this information to your Clora profile?</h2>
            <div className="g-row">
              <button
                className={`g-flex-50 full-width btn btn-secondary bigger-button mr-40 did-not-claim-${page}`}
                onClick={() => this.nextPage()}
              >
                No, I will set my own profile
              </button>
              <button
                className={`g-flex-50 full-width btn btn-primary bigger-button claim-info-${page}`}
                onClick={() => this.claimInfo()}
              >
                Yes, add to my profile
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Beginning.propTypes = {
  questionnaire: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape([]))).isRequired,
  questionnaireName: PropTypes.string.isRequired,
  questionableId: PropTypes.string.isRequired,
  questionableType: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  isOwner: PropTypes.bool.isRequired,
  claimInfoUrl: PropTypes.string.isRequired,
  setStateQuestionnaire: PropTypes.func.isRequired,
  updateQuestionnaire: PropTypes.func.isRequired,
  handleNextStep: PropTypes.func.isRequired,
  onboardType: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  bio: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
  education: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  pastRoles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  functionalAreas: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  therapeuticAreas: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  industries: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  productTechnologies: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  stagesOfDevelopments: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  updateMenu: PropTypes.bool.isRequired,
  uploadingResume: PropTypes.bool.isRequired,
  handleMenuUpdate: PropTypes.func.isRequired,
  handleResumeUpload: PropTypes.func.isRequired,
  errorsProfileSuggestions: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state) => {
  const { profileSuggestions, errors: errorsProfileSuggestions } = state.profileSuggestions;

  return {
    ...profileSuggestions.merged,
    errorsProfileSuggestions,
  };
};

export default connect(mapStateToProps)(Beginning);
